(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1389],{

/***/ 7995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return __webpack_require__(4949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7865);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var Skelet = function(param) {
    var children = param.children, height = param.height, maxHeight = param.maxHeight, width = param.width, maxWidth = param.maxWidth, style = param.style, className = param.className, invert = param.invert;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().skelet),
            className,
            invert && (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().invert)
        ].filter(Boolean).join(" "),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: height,
            maxHeight: maxHeight,
            width: width,
            maxWidth: maxWidth
        }, style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skelet);


/***/ }),

/***/ 4949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3193);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(798);
/* harmony import */ var _components_Skelet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3177);
/* harmony import */ var _styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8645);
/* harmony import */ var _styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var FavoritesStatistic = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 182).then(__webpack_require__.bind(__webpack_require__, 182));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(182)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "block",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().statistics),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            height: 120,
                            width: 120,
                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().statisticsGraph)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            height: 120,
                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().statisticsContent)
                        })
                    ]
                })
            })
        });
    }
});
var FavoritesList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7953).then(__webpack_require__.bind(__webpack_require__, 7953));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7953)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "block",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().list),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listHeader),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                height: 33,
                                maxWidth: 200,
                                className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listHeaderTitle)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listContent),
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Array(3).keys()).map(function(value) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItem),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemGallery),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemGalleryPhoto),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    style: {
                                                        position: "absolute",
                                                        height: "100%",
                                                        borderRadius: 20
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemData),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemPrice),
                                                    height: 33,
                                                    maxWidth: 200
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemAddress),
                                                    height: 21,
                                                    maxWidth: 240
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemProperties),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemProperty),
                                                            width: 60,
                                                            height: 32,
                                                            style: {
                                                                marginRight: 12
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemProperty),
                                                            width: 60,
                                                            height: 32,
                                                            style: {
                                                                marginRight: 12
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemProperty),
                                                            width: 60,
                                                            height: 32,
                                                            style: {
                                                                marginRight: 12
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemDescription),
                                                    height: 110
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemActions),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_modules_favorites_Favorites_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listItemDate)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            width: 150,
                                                            height: 44,
                                                            style: {
                                                                borderRadius: 18
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, value);
                            })
                        })
                    ]
                })
            })
        });
    }
});
var FavoritesPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                noindex: true,
                nofollow: true,
                title: "Избранное",
                description: "Избранное: объекты недвижимости.",
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: "Избранное",
                    description: "Избранное: объекты недвижимости",
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavoritesStatistic, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavoritesList, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FavoritesPage);


/***/ }),

/***/ 7865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};

/***/ }),

/***/ 8645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"statistics":"Favorites_statistics__A6tIR","statisticsGraph":"Favorites_statisticsGraph__huyWs","statisticsContent":"Favorites_statisticsContent__8dEzl","list":"Favorites_list__No0Ls","listHeader":"Favorites_listHeader__tmZ64","listContent":"Favorites_listContent__DVs6x","listItem":"Favorites_listItem__5xFLd","listItemGallery":"Favorites_listItemGallery__Ywt8J","listItemGalleryPhoto":"Favorites_listItemGalleryPhoto__XEubs","listItemData":"Favorites_listItemData__XpAAd","listItemPrice":"Favorites_listItemPrice__0tR7g","listItemAddress":"Favorites_listItemAddress__buYpV","listItemProperties":"Favorites_listItemProperties__IF77T","listItemProperty":"Favorites_listItemProperty___cJnl","listItemDescription":"Favorites_listItemDescription__jr3_1","listItemActions":"Favorites_listItemActions__pfH0I","listItemDate":"Favorites_listItemDate__qxRMP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,798,3193,9774,2888,179], function() { return __webpack_exec__(7995); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);